module.exports = __webpack_public_path__ + "img/users-sqr.f11a6b32.svg";